import { defineMessages } from '@formatjs/intl';

export const breatheScreenMessages = defineMessages({
	title: {
		id: 'signup.breatheScreen.title',
		defaultMessage: 'One moment while we tailor your experience…',
		description: 'Message shown while the page loads a personalized plan',
	},
});
